import React from "react";
import { useDownloadCertificate } from "@pages/vessel-management/vessel-status/hooks/useDownloadCertificate";
import { useTranslation } from "react-i18next";
import CallAdditionalDocumentsCard from "./CallAdditionalDocumentsCard";

interface AdditionalDocumentPreviewItem {
  name?: string;
  specify?: string | null;
  type?: string;
  summary?: string;
  fileName?: string;
  originalFileName?: string;
  issueDate?: Date | string;
  expiryDate?: Date | string;
  url?: string;
}

interface CallAdditionalDocumentsPreviewProps {
  additionalRemarks?: string;
  additionalDocuments?: AdditionalDocumentPreviewItem[];
}

const CallAdditionalDocumentsPreview: React.FC<CallAdditionalDocumentsPreviewProps> = ({
  additionalRemarks,
  additionalDocuments,
}) => {
  const { handleDownload, handlePreview } = useDownloadCertificate();
  const { t } = useTranslation();

  const TEST_ID_BASE = "vessel-status-page";
  const LANG_BASE = "vessel-call";

  return (
    <div className="mt-6">
      <div className="mb-6" data-testid={`${TEST_ID_BASE}-additional-remarks`}>
        <p className="font-semibold text-sm mb-2">
          {t(`${LANG_BASE}.additional-documents.remarks-instructions`)}
        </p>
        <p className="text-sm whitespace-pre-wrap">{additionalRemarks || "-"}</p>
      </div>
      {!additionalDocuments?.length ? (
        <div
          className="text-center text-gray-500 py-8"
          data-testid={`${TEST_ID_BASE}-additional-documents-empty`}
        >
          {t(`${LANG_BASE}.additional-documents.empty`)}
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {additionalDocuments.map(
            (
              {
                name,
                fileName,
                originalFileName,
                issueDate,
                expiryDate,
                url,
                specify,
                type,
                summary,
              },
              idx,
            ) => (
              <div key={`${name}-${idx}`} className="w-full">
                <CallAdditionalDocumentsCard
                  testId={`${TEST_ID_BASE}-additional-document-${idx}`}
                  onDownload={() =>
                    handleDownload(
                      "document",
                      "bff-vessel",
                      url || "",
                      fileName || originalFileName || name || "",
                    )
                  }
                  onPreview={() => handlePreview("document", "bff-vessel", url || "")}
                  fileName={fileName || originalFileName}
                  url={url}
                  issueDate={issueDate}
                  expiryDate={expiryDate}
                  documentType={type}
                  otherSpecifyType={specify ?? undefined}
                  documentSummary={summary}
                  documentName={name}
                />
              </div>
            ),
          )}
        </div>
      )}
    </div>
  );
};

export default CallAdditionalDocumentsPreview;
